import { render, staticRenderFns } from "./addChild.vue?vue&type=template&id=0bdf2bb5&scoped=true&"
import script from "./addChild.vue?vue&type=script&lang=js&"
export * from "./addChild.vue?vue&type=script&lang=js&"
import style0 from "./addChild.vue?vue&type=style&index=0&id=0bdf2bb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdf2bb5",
  null
  
)

export default component.exports